import { tuitionFeePriceStudent } from '@/plugins/api'
import alert from '@/plugins/alert'
import loadingCount from '@/plugins/loadingCount'
import { chunk, rangeRight } from 'lodash-es'
export default {
  namespaced: true,
  state: {
    priceStudents: [],
    listStudentError: [],
    loading: false,
    itemsPerPage: 10,
    studentSearch: {},
    totalItems: 0,
  },
  actions: {
    async createTuitionFeePriceStudent(_, { rootPrice, students, headFee }) {
      try {
        let count = 0
        let prices = {}
        const delay = (ms) =>
          new Promise(
            (res) => setTimeout(res, ms),
            () => {}
          )
        let arrStudents = chunk(students, 10)
        for await (const studentCurt of arrStudents) {
          for await (const student of studentCurt) {
            loadingCount.count(count)
            prices[`${student.code}`] = {
              amount: student.price,
              type: student.type.includes('%') ? 'percentage' : 'fixed',
              notes: student.notes,
            }
            loadingCount.count(count)
            count++
            await delay(100)
          }
          let params = {
            rootPriceId: rootPrice._id,
            headFeeId: headFee.id,
            periodId: rootPrice.period._id,
            prices: prices,
          }
          prices = {}
          await tuitionFeePriceStudent.addPack(params)
        }
        alert.updateSuccess('Học viên')
      } catch (err) {
        let strError = err.replace('Học viên không tồn tại trên hệ thống ', '')
        let error = strError.split(',')
        let mesError = ''
        for (const err of error) {
          mesError += `Mã học viên ${err} không tồn tại.<br/>`
        }
        alert.addPeriodError({
          title: 'Lỗi dữ liệu',
          description: mesError,
        })
      }
    },
    async removePriceStudents(_, rootPrice) {
      try {
        await tuitionFeePriceStudent.removePriceStudent(rootPrice.id)
      } catch (error) {
        alert.addError(error)
      }
    },
    async requestPageSettings({ state, commit, dispatch }, { page, itemsPerPage }) {
      state.loading = true
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage
      if (state.studentSearch) {
        const studentSearch = {
          ...state.studentSearch,
          _start: (page - 1) * itemsPerPage,
          _limit: itemsPerPage,
        }
        const [totalItems, priceStudents] = await Promise.all([
          tuitionFeePriceStudent.count(studentSearch),
          tuitionFeePriceStudent.search(studentSearch),
        ])

        if (totalItems > (page - 1) * itemsPerPage || page === 1) {
          commit('changeState', {
            totalItems,
            itemsPerPage,
            studentSearch,
            priceStudents,
          })
        } else {
          var pages = rangeRight(1, page)
          for (let index = 0; index < pages; index++) {
            const selectedPage = pages[index]
            if (totalItems > (selectedPage - 1) * itemsPerPage) {
              dispatch('requestPageSettings', {})
              break
            }
          }
        }
      }
      state.loading = false
    },
    async fetchPriceStudents(_, rootPrice) {
      let priceStudents = []
      let params = {
        rootPrice: rootPrice.id,
      }
      let res = await tuitionFeePriceStudent.search(params)
      res.forEach((item, index) => {
        const { price, type, notes } = item
        priceStudents.push({ ...item.student, index: index + 1, price, type, notes })
      })
      return priceStudents
    },
  },
  mutations: {
    setHeadFees(state, headFees) {
      state.headFees = headFees
    },
    setListStudentError(state, studentError) {
      state.listStudentError = studentError
    },
  },
  getters: {
    priceStudents: (state) => state.priceStudents,
  },
}
